import React, { useState } from 'react';
import { Table, Badge, Typography, Input, Space, Card, Select, Button } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
 
const { Search } = Input;
const { Option } = Select;
 
const AgentTable = ({ data}) => {
  console.log('Frontend data:',data)
  const [searchText, setSearchText] = useState('');
  const [selectedProfiles, setSelectedProfiles] = useState([]);
 
  const handleProfileChange = (values) => {
    setSelectedProfiles(values);
  };
  //NEEDS TO BE UPDATED FOR CURRENT CHANGE TO QUEUE NAME
   const allowedProfilesList =['Purple Routing Profile','Red Routing Profile',
  'KDOC Routing Profile','Blue Routing Profile','HSA Routing Profile',
   'IR Routing Profile','Green Routing Profile','Purple Routing Profile',
   'LIEAP']
 
  const safeData = Array.isArray(data) ? data : [];
  console.log('safeData:',safeData);
  const filteredAgents = safeData.filter(agent => allowedProfilesList.includes(agent.routingProfile));
   const routingProfiles = [...new Set(filteredAgents.map((a)=> a.routingProfile).filter(Boolean))];
  const filteredData = filteredAgents.filter(agent =>
    agent.agentname?.toLowerCase().includes(searchText.toLowerCase())
  ).filter(agent =>
    selectedProfiles.length === 0 || selectedProfiles.includes(agent.routingProfile)
  );
  const getColumnSearchProps = dataIndex => ({
  filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    <div style={{ padding: 8 }}>
      <Search
        placeholder={`Search ${dataIndex}`}
        value={selectedKeys[0]}
        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
        onPressEnter={() => confirm()}
        style={{ width: 200, marginBottom: 8, display: "block" }}
      />
      <div>
        <button onClick={() => confirm()} style={{ marginRight: 8 }}>Search</button>
        <button onClick={() => { clearFilters(); }}>Reset</button>
      </div>
    </div>
  ),
  filterIcon: filtered => <span style={{ color: filtered ? "#1890ff" : undefined }}>🔍</span>,
  onFilter: (value, record) => record[dataIndex].toLowerCase().includes(value.toLowerCase()),});
 
  const columns = [
    {
      title: 'Name',
      dataIndex: 'agentname',
      sorter: (a, b) => a.agentname?.localeCompare(b.agentname),...getColumnSearchProps("agentname"),
      sortDirections: ['ascend', 'descend']
    },
    { title: 'Routing Profile', dataIndex: 'routingProfile',...getColumnSearchProps("routingProfile") },
    { title: 'On Contact Queue', dataIndex: 'queue',...getColumnSearchProps("queue") },
    {
      title: 'Status',
      dataIndex: 'status',
      sorter: (a, b) => a.status.localeCompare(b.status),...getColumnSearchProps("status"),
      sortDirections: ['ascend', 'descend'],
      render: status => (
        <Badge
          status={{
            'Online': 'success',
            'On a Call': 'processing',
            'After Call Work': 'Warning',
            'Offline': 'default'
          }[status] || 'default'}
          text={status}
          color={
              status === 'Online' ? 'green' : status === 'On a Call' ? 'purple' : status === 'After Call Work' ? 'yellow' : status === 'Available'? 'green' : status === 'Offline' ? 'grey' : 'grey'
          }
        />
      )
    },
    { title: 'Updated', dataIndex: 'lastUpdated' }
  ];
console.log('columns:',columns)
  return (
    <>
    <Card title="Agent Status" hoverable>
      <Space style={{ marginBottom: 16 }} direction='horizontal'>
      <Select
        mode = 'multiple'
        style={{width: 300}}
        placeholder= "Filter by Routing Profile"
        value = {selectedProfiles}
        onChange={handleProfileChange}
        allowClear>
        {routingProfiles.map((profile) => (
          <Option Key={profile} value={profile}>
          {profile}
          </Option>
        ))}
        </Select>
        <Input
          placeholder="Search by name"
          allowClear
          onChange={e => setSearchText(e.target.value)}
          style={{ width: 250 }}
        />
      </Space>
      <Table
        columns={columns}
        dataSource={filteredData}
        rowKey="agentname"
        pagination={{
          pageSize: 10,
        }}
      />
      </Card>
    </>
  );
};
export default AgentTable;